/** @jsx jsx */

import { get, upperFirst } from 'lodash';

import { Icon, IconName } from '@zapier/zinnia-icons';
import { ColorName, Grid, Text } from '@zapier/design-system';
import { css, jsx } from '@emotion/core';

import Link from 'app/common/components/Link';
import { BASE_DOC_URL_VB } from 'app/developer-v3/constants';

import type { ImplementationValidationCheck } from 'app/developer-v3/types';

const Styles = {
  issueDetails: css`
    :not(:last-of-type): {
      margin-bottom: 20px;
    },
  `,
  issuesList: css`
    margin: 0;
  `,
  resultsList: css`
    margin-left: 40px;
    margin-bottom: 0;
  `,
};

const iconsMap: {
  errors: {
    name: IconName;
    color: ColorName;
  };
  warnings: {
    name: IconName;
    color: ColorName;
  };
} = {
  errors: { name: 'formXCircle', color: 'StatusError' },
  warnings: { name: 'alertCircleColor', color: undefined },
};

const checkMap = {
  read: 'Trigger',
  write: 'Action',
  search: 'Search',
  auth: 'Auth',
  meta: 'Meta',
};

type Props = {
  type: 'errors' | 'warnings';
  checks: Array<ImplementationValidationCheck>;
};

const StyleChecks = (props: Props) => (
  <div>
    <Text tag="h4" type="Title">
      {props.type}
    </Text>
    <ul aria-label={`Validation ${props.type} List`} css={Styles.issuesList}>
      {props.checks.map(check =>
        get(check, 'violations', []).map(violation => (
          <li
            aria-label="Validation Issue"
            css={Styles.issueDetails}
            key={`${props.type}-${violation.type}`}
          >
            <Grid alignItems="center" columns="24px auto" gap={10}>
              <Icon
                color={iconsMap[props.type].color}
                name={iconsMap[props.type].name}
                size={30}
              />
              {`${checkMap[check.type]} (${violation.type}):`}
            </Grid>
            <ol css={Styles.resultsList}>
              {get(violation, 'results', []).map((result, idxResult) => (
                <li aria-label="Validation Details" key={idxResult}>
                  {upperFirst(result.message)} (
                  <Link
                    href={`${BASE_DOC_URL_VB}/publish/integration-checks-reference#${result.tag}`}
                    target="_blank"
                  >
                    {result.tag}
                  </Link>
                  )
                </li>
              ))}
            </ol>
          </li>
        ))
      )}
    </ul>
  </div>
);

export default StyleChecks;
